module.exports = __webpack_public_path__ + "img/5.a816d830.png";